/*=============================================
=            Table Styling            =
=============================================*/

:host {
  @apply flex;

  &.pk-table {
    @apply w-full flex-col;
  }
}
